import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GameProvider } from './contexts/GameContext.tsx';
import { SignalRProvider } from './contexts/SignalRContext.tsx';
import HomePage from './pages/HomePage.tsx';
import RoomPage from './pages/RoomPage.tsx';
import GamePage from './pages/GamePage.tsx';
import NotFoundPage from './pages/NotFoundPage.tsx';
import './App.css';

const App: React.FC = () => {
  return (
    <SignalRProvider>
      <GameProvider>
        <Router>
          <div className="min-h-screen bg-gray-100">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/room/:roomId" element={<RoomPage />} />
              <Route path="/game/:roomId" element={<GamePage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </Router>
      </GameProvider>
    </SignalRProvider>
  );
};

export default App;
